import { Box } from '@mui/material';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import MWXNavBar from '../../components/navBar/MWXNavBar';

export const Route = createFileRoute('/_authenticated/_navbar')({
  component: NavbarLayout,
});

function NavbarLayout() {
  return (
    <Box>
      <MWXNavBar />
      <Outlet />
    </Box>
  );
}
